/** Englische Fassungen für den Bereich „cockpit" (Schlüssel = deutscher Satz). */
export const EN_COCKPIT: Record<string, string> = {
  'Heute für dich: Seiten wechseln': 'Today for you: change pages',
  '{from}–{to} von {total}': '{from}–{to} of {total}',
  'heute': 'today',
  'morgen': 'tomorrow',
  'Wird neu gebaut. Du siehst es im Kalender, sobald es fertig ist.': 'Rebuilding. You\'ll see it in the calendar once it\'s done.',
  'Wird erneut gesendet.': 'Sending again.',
  'Neu bauen fehlgeschlagen': 'Rebuild failed',
  'Senden fehlgeschlagen': 'Sending failed',
  'Die Automatik ist aus. Neue Beiträge entstehen, wenn du auf „Jetzt Beiträge bauen" klickst.': 'Automation is off. New posts are created when you click “Build posts now”.',
  'Die Automatik pausiert: {reason}': 'Automation is paused: {reason}',
  'Der Agent legt von selbst nach. Beiträge gehen ohne Rückfrage live.': 'The agent tops up on its own. Posts go live without asking.',
  'Der Agent legt von selbst nach. Live geht erst, was du freigibst.': 'The agent tops up on its own. Only what you approve goes live.',
  'Einrichtung': 'Setup',
  'Jetzt Beiträge bauen': 'Build posts now',
  'Alle Schritte': 'All steps',
  'Du bist dran': 'Your turn',
  'Der Termin des ältesten ist schon vorbei. Gibst du ihn frei, geht er sofort raus. Was du nicht brauchst, verwirf.': 'The oldest one is already past its slot. If you approve it, it goes out right away. Discard what you don\'t need.',
  'Der erste soll {day} um {time} raus. Gib ihn bis dahin frei, sonst rückt er einen Termin nach hinten.': 'The first one is due {day} at {time}. Approve it by then, or it moves back one slot.',
  'Sieh sie dir an und gib frei, was raus darf. Ohne dein OK geht nichts live.': 'Look them over and approve what may go out. Nothing goes live without your OK.',
  'Jetzt prüfen': 'Review now',
  '„{hook}" ging nicht überall raus': '“{hook}” didn\'t go out everywhere',
  '„{hook}" konnte nicht gebaut werden': '“{hook}” couldn\'t be built',
  '„{hook}" ist fehlgeschlagen': '“{hook}” failed',
  'Es wurde kein Grund gemeldet.': 'No reason was reported.',
  'Gesendet wird nur an: {targets}.': 'It will only be sent to: {targets}.',
  'Dazu {n} weitere fehlgeschlagene Beiträge im Kalender.': 'Plus {n} more failed posts in the calendar.',
  'Neu bauen': 'Rebuild',
  'Neu senden': 'Send again',
  'Details': 'Details',
  'Bis du {platform} neu verbindest, geht dort nichts raus. Geplante Beiträge bleiben liegen.': 'Until you reconnect {platform}, nothing goes out there. Scheduled posts stay on hold.',
  'Alles erledigt': 'All done',
  'Dein Feed läuft. Nächster Beitrag {when}.': 'Your feed is running. Next post {when}.',
  'Alles erledigt. Gerade ist nichts geplant.': 'All done. Nothing is scheduled right now.',
  'Kalender öffnen': 'Open calendar',
  'Aus': 'Off',
  'Vollautomatisch': 'Fully automatic',
  'Mit Freigabe': 'With approval',
  'Beitrag selbst erstellen': 'Create a post yourself',
  'Ein Lauf arbeitet gerade.': 'A run is in progress.',
  'Baut gerade…': 'Building…',
  'Die AI liest noch dein Briefing und ergänzt Untertitel, Tonfall und erste Ideen. Das dauert meist unter einer Minute.': 'The AI is still reading your briefing and adding subtitle, tone and first ideas. This usually takes under a minute.',
  'Nächster Schritt': 'Next step',
  'Kalender ansehen': 'View calendar',
  'Gerade passiert': 'Happening now',
  'live': 'live',
  'Der Agent {phase}': 'The agent: {phase}',
  '{p} % · {n} Beiträge nach „{recipe}"': '{p}% · {n} posts using “{recipe}”',
  '{p} % · {n} Beiträge': '{p}% · {n} posts',
  '+{n} weitere Läufe': '+{n} more runs',
  'Kein Lauf aktiv. Nächster automatischer Lauf: {when}.': 'No run active. Next automatic run: {when}.',
  'Kein Lauf aktiv. Der Agent baut nach, sobald Plätze frei werden.': 'No run active. The agent builds more as soon as slots open up.',
  'Kein Lauf aktiv. Automatik ist aus.': 'No run active. Automation is off.',
  'Letzter Lauf {when}': 'Last run {when}',
  'Läufe ansehen →': 'View runs →',
  'Aus. Der Agent baut nur, wenn du auf „Jetzt Beiträge bauen" klickst.': 'Off. The agent only builds when you click “Build posts now”.',
  '{freq}{windows}. {rest}': '{freq}{windows}. {rest}',
  'um {labels} Uhr': 'at {labels}',
  'Der Agent baut von selbst nach, Beiträge gehen ohne Rückfrage live.': 'The agent builds more on its own, posts go live without asking.',
  'Der Agent baut von selbst nach, live geht erst, was du freigibst.': 'The agent builds more on its own, only what you approve goes live.',
  'Pausiert: {reason}': 'Paused: {reason}',
  'Zeitplan-Änderung noch nicht übernommen, unter Automatik bestätigen.': 'Schedule change not applied yet, confirm it under Automation.',
  'Ändern →': 'Change →',
  'Als Nächstes geht raus': 'Going out next',
  '{n} geplant oder in Arbeit': '{n} scheduled or in progress',
  'Ganzer Kalender →': 'Full calendar →',
  'Nichts geplant. Starte einen Lauf oder schalte die Automatik ein.': 'Nothing scheduled. Start a run or turn on automation.',
  'Views · 30 Tage': 'Views · 30 days',
  '{n} Credits in den letzten 30 Tagen': '{n} credits in the last 30 days',
  '≈ {n} Credits pro Beitrag': '≈ {n} credits per post',
  'noch nichts live': 'nothing live yet',
  'Fehlt: {step} →': 'Missing: {step} →',
  'Alles eingerichtet ✓': 'All set up ✓',
  'Startklar ✓ · {n} optional': 'Ready ✓ · {n} optional',
  'Beiträge bauen lassen': 'Have posts built',
  '1 Beitrag bauen': 'Build 1 post',
  '{n} Beiträge bauen': 'Build {n} posts',
  'Der Agent erfindet Hooks, erzeugt die Medien, schreibt Captions und legt alles als Entwurf ab. Veröffentlicht wird erst nach deiner Freigabe.': 'The agent comes up with hooks, creates the media, writes captions and saves everything as drafts. Nothing is published until you approve it.',
  'anderes wählen': 'choose another',
  'Wie viele Beiträge?': 'How many posts?',
  '1 Beitrag': '1 post',
  '{n} Beiträge': '{n} posts',
  'Guten Morgen': 'Good morning',
  'Guten Tag': 'Good afternoon',
  'Guten Abend': 'Good evening',
  'Alle Projekte auf einen Blick – und was heute deine Aufmerksamkeit braucht.': 'All projects at a glance, and what needs your attention today.',
  'Heute für dich': 'Today for you',
  '1 Ding braucht dich': '1 thing needs you',
  '{n} Dinge brauchen dich': '{n} things need you',
  'Geführt in 5 Schritten, ca. 3 Minuten': 'Guided in 5 steps, about 3 minutes',
  'Prüfen, alle Projekte': 'Review, all projects',
  'Über alle Projekte': 'Across all projects',
  '{views} Views · {followers} Follower · {credits} Credits in 30 Tagen': '{views} views · {followers} followers · {credits} credits in 30 days',
  'Wird vorbereitet, die AI liest dein Briefing': 'Getting ready, the AI is reading your briefing',
  'Nächster Beitrag {when}': 'Next post {when}',
  'Nächster Lauf {when}': 'Next run {when}',
  'Nichts geplant': 'Nothing scheduled',
  'Neuer Versuch gleich…': 'Trying again shortly…',
  'Was nicht entstanden ist, wurde auch nicht berechnet. Starte einen neuen Lauf, wenn die Ursache behoben ist.': 'Nothing that was not created was charged. Start a new run once the cause is fixed.',
  'nicht gestartet': 'not started',
  'Text schreiben': 'Write text',
  'Bilder generieren': 'Generate images',
  'Musik wählen': 'Choose music',
  'In die Queue legen': 'Add to queue',
  'Gerade ist viel los, die Erzeugung wurde abgewiesen. Das legt sich meist nach wenigen Minuten. Danach lässt sich der Lauf fortsetzen, ohne neu zu planen.': 'The service is busy and rejected the request. This usually clears within a few minutes. Afterwards the run can continue without re-planning.',
  'Der Lauf reagierte nicht mehr und wurde beendet. Die reservierten Credits sind zurück.': 'The run stopped responding and was ended. The reserved credits have been returned.',
};
